module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_1@2x.b5d3d140.png";